var map = {
	"./Amazon Logo.png": 6545,
	"./Capitec Logo.png": 2610,
	"./Coca Cola Logo.png": 5808,
	"./KFC Logo.png": 7741,
	"./McDonalds Logo.png": 3850,
	"./Mondelez Logo.png": 8349,
	"./Mr D Logo.png": 3798,
	"./PepsiCo Logo.png": 9040,
	"./Rainmaker Logo.png": 1941,
	"./Takealot Logo.png": 864,
	"./Unilever Logo.png": 8411,
	"./Woolworths Logo.png": 741,
	"./inDrive logo.png": 4146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7569;